export default {
  tabbar1: "home",
  tabbar2: "cinema",
  tabbar3: "choose",
  tabbar4: "vote",
  tabbar5: "mine",
  login: "login",
  userNamePlaceholder: "Please enter one user name",
  passwordPlaceholder: "Please enter the password",
  forgotPassword: "Forgot password?",
  noAccount: "No account?",
  registerNow: "Register Now",
  register: "register",
  inviteCodeePlaceholder: "Please enter the invitation code",
  consentAgreement:
    "I am aware of and agree to the various treaties of the 'Account Opening Agreement'",
  highEndZone: "High end zone",
  EnjoyTheUltimateLuxuryExperience: "Enjoying Luxury Body",
  airborne: "airborne",
  viewMoreData: "View more data",
  aboutCannonRecommend: "Recommendation for appointment",
  current: "current",
  peopleNowMatch: "Human online matching",
  accountMembership: "Successfully joined the association",
  highEnd: "dear",
  authentication: "auth",
  videoAuthentication: "videoAuth",
  tollRange: "Toll range",
  personHeight: "height",
  bust: "bust",
  serviceCity: "Service City",
  nationalAirborne: "National Airborne",
  askHerOut: "Ask her out",
  uptodate: "new",
  play: "play",
  reservation: "reservation",
  beautifulGirl: "beautiful girl",
  people: "per",
  requiredPromotion: "Required for promotion",
  integral: "integral",
  rechargePoints: "Recharge points",
  redeemPoints: "Redeem points",
  myActivityPoints: "My activity points",
  currencySymbol: "integral",
  basicInformation: "Basic information",
  personalReports: "Personal Reports",
  loginPassword: "Login password",
  paymentPassword: "payment password",
  taskLog: "Task Log",
  noticeAnnouncement: "System Announcement",
  onlineService: "Online Service",
  logOut: "Log out of login",
  residence: "residence",
  reservationNow: "Start Dating Now",
  photo: "photo",
  video: "video",
  personalProfile: "Personal Profile",
  popularRecommendations: "Popular recommendations",
  switchWindows: "switch windows",
  designatedTime: "stage",
  votingResults: "Voting results",
  ISSUE: "ISSUE",
  data: "data",
  big: "Tokyo",
  small: "Yokohama",
  one: "Osaka",
  two: "Nagoya",
  currentSelectedNumber: "Current selected number",
  pointsPerOrder: "Points per order",
  inTotal: "total",
  amountMoney: "amount",
  availablePoints: "Available points",
  submitTo: "submit",
  artilleryEngagement: "Artillery engagement",
  recharge: "Recharge",
  payeeName: "Payee name",
  bankName: "Bank Name",
  bankCardNumber: "Bank card number",
  bankCardNumberPlaceholder: "Please enter your bank card number",
  branchName: "Branch name",
  branchNumber: "Branch number",
  selectBank: "Please select a bank",
  nameOfPayer: "Name of payer",
  uploadPaymentVoucher: "Upload payment voucher",
  rechargePrompt:
    "Please do not repeat the operation. If you have not received payment for a long time, please contact the customer.",
  confirmRecharge: "Confirm recharge",
  exchangeRecords: "Records",
  whole: "whole",
  limitDescription: "Limit Description",
  singleTransactionLimit: "Single transaction limit",
  minimum: "minimum",
  highest: "highest",
  withdrawalFrequency: "Withdrawal frequency",
  dailyHighest: "Daily highest",
  order: "order",
  freeOfHandlingFees: "(Free of handling fee 500 times)",
  receiptTime:
    "Arrival time: Generally, the arrival time is around 5 minutes, and the fastest time to arrive is within 2 minutes",
  residualIntegral: "Residual integral",
  individual: "pcs",
  redeemPointsNow: "Refund Now",
  headSculpture: "head sculpture",
  fullName: "name",
  gender: "sex",
  male: "Male",
  female: "Female",
  unknown: "unknown",
  bankCardInformation: "Bank card information",
  have: "have",
  notHave: "not have",
  modifyRealName: "Modify real name",
  save: "save",
  fullNamePlaceholder: "Please enter your name",
  modifyRealNameRemake:
    "To ensure account security, the real name must be the same as the name of the bound bank card.",
  modifyGender: "Modify Gender",
  cardNumber: "Bank Name",
  cardName: "User name",
  cardID: "Bank card number",
  addBankCard: "Add Bank Card",
  addBankCardRemake:
    "Note: Please consult with large commercial banks. If changes are needed, please contact customer service online.",
  payCardInfoPlaceholder: "Please enter your payment card information",
  addBankCardPrompt:
    "Dear user, to ensure the security of your funds, please link your real name and set a withdrawal password. If your name does not match your account name, you will not be able to withdraw funds.",
  personalReport: "Personal Report",
  profitPoints: "Profit points",
  profiCalculationFormula:
    "Profit calculation formula: winning points - task points",
  taskPoints: "Task points",
  withdrawalPoints: "Withdrawal points",
  winningPoints: "Winning points",
  changeLoginPassword: "Change login password",
  oldPwd: "Old password",
  oldPwdPlaceholder: "Please enter your old password",
  newPwd: "Password",
  newPwdPlaceholder: "Please enter your new password",
  againOldPwdPlaceholder: "Please enter your new password again",
  taskRecord: "Task Record",
  emptyData: "Data is empty",
  betPoints: "Order points",
  orderTime: "Order time",
  settlementTime: "Settlement time",
  refreshSuccessful: "Refresh successful!",
  invalidFunction: "This function is invalid!",
  appointmentSuccessful: "Appointment successful!",
  completeActivationTask: "Please complete the activation task.",
  checkAgreement: "Please check the account opening agreement below",
  integralError: "Integral error!",
  selectNumber: "Please select a number!",
  fillInPoints: "Please fill in the points!",
  insufficientPoints:
    "Insufficient points, please contact customer service to recharge!",
  contactCollect: "Please contact the administrator to claim this task!",
  successfulLotteryDraw: "Successful lottery draw, issue:",
  notSet: "not set",
  contactService:
    "If you need to change your password, please contact customer service.",
  completeTask: "Please enter after completing the task list",
  setUpBankCard: "Please set up a bank card",
  accountOffline: "Account offline",
  fileTooLarge: "file too large",
  formatRule: "Please upload an image in the correct format",
  uploadSuccessful: "Upload successful",
  amountError: "Amount error",
  setNameToBindBankCard: "Please set the name before binding to the bank card",
  setWithdrawalPasswordToBindBankCard:
    "Please set the withdrawal password before binding to the bank card",
  passwordInconsistency: "Password inconsistency",
  complete: "Please fill in completely",
  changWithdrawalPasswordContactSustomerService:
    "The withdrawal password has been set and needs to be modified. Please contact customer service",
  activateWatchVideo: "Please activate and watch the video",
  rechargeWatchVideo: "Please recharge and watch the video",
  pour: "pour",
  taskList: "Task List",
  clearOrder: "Clear Order",
  confirmSub: "Confirm",
  switchLanguage: "Switch language",
  illustrate: "illustrate",
  submissionTime: "Submission time",
  auditTime: "Audit time",
  payPwdPl: "Please enter the payment password",
  enterPayPwdPl: "Please re-enter the payment password",
  setPayPwd: "Set payment password",
  yse: "yes",
  loadingtext: "Loading...",
  finishedtext: "There is no more data",
  pullingtext: "Pull down to refresh",
  loosingtext: "Release and refresh",
  bettingContent: "Order content",
  xinyufen: "Credit score",
  applyMembershipCard: "Apply for a membership card",
  xqaltit: "Happy Story",
  LastUpdated: "Last Updated",
  tpzx: "Voting Center",
  grzx: "Personal Center",
  ljmfks: "Start for Free Now",
  rgnyzh: "Already have an account",
  bfwbxsbsyxkf:
    "Users under the age of 18 are not allowed to use this service.",
  aqkkdppfw: "A safe and secure matching service format: “IMS Certification”",
  ckgdxqal: "View other matchmaking examples",
  syqlaqkkdyy: "Why it is safe and secure to use",
  syqlaqkkdjtnr:
    "We implement various measures to ensure that users seeking serious relationships can use our service with peace of mind and safety.",
  safetit011: "24 hours a day, 365 days a year",
  safetit012: "Strict monitoring system",
  safecon01:
    "By combining technology with continuous human monitoring, we provide a safe and secure service for all users.",
  safetit02: "Identity verification is required",
  safecon02:
    "To exchange messages, identity verification using an official ID with a photo is required.",
  safetit03: "Real names are not displayed",
  safecon03:
    "Profiles are displayed using initials or nicknames, so real names are never shown.",
  safetit041: "Malicious users will be",
  safetit042: "forcibly removed",
  safecon04:
    "In addition to user violation reports, we use AI to detect fraudulent and malicious users and take strict actions such as warnings and forced account termination.",
  safetit051: "Will not be posted",
  safetit052: "on social media",
  safecon05:
    "Even if you register using social media accounts such as LINE, no posts will be made.",
  safetit061: "We have obtained",
  safetit062: "various certifications",
  safecon06:
    "We have obtained the personal information security mark “TRUSTe Certification” and the “IMS Certification Mark” awarded to properly operated matching service providers.",
  cwwt: "Frequently Asked Questions",
  q1: "Can I use the service for free?",
  a1:
    "Registration and matching are free. For free members, men can send the first message, while women can send and receive messages.",
  q2:
    "Can I use the service without my profile being visible to an unspecified number of people?",
  a2:
    "We recommend using the “Private” setting, which allows only users you have liked or matched with to view your profile. This feature is available to all members for free.",
  q3: "I am worried about getting involved in trouble",
  a3:
    "We have established a “Safety Center” that consolidates information for safe and secure use. If you still have concerns, please contact our Customer Support.",
  cbdjmtbd: "has been featured in numerous media outlets",
  gzhyhhjzc: "Various marriage and matchmaking support programs",
  wzzcyzgxm: "Participating projects",
  xm1:
    "A general incorporated association established with sponsorship from various companies to support marriage and matchmaking in Japan.",
  xm2:
    "A marriage support program promoted by Kanagawa Prefecture to help those who wish to get married achieve their goals.",
  xm3:
    "A youth matchmaking support initiative promoted by Yokote City, Akita Prefecture, aimed at addressing the declining birthrate.",
  zxyhfwzch: "Internet-based matchmaking service registered: Shibuya 25-001649",
  slfh: "(Acceptance Number: 30230025-004)",
  sm: "statement",
};
